import React from "react";

import { TableFooter, TablePagination, TableRow } from "@material-ui/core";
import { isUndefined } from "../../../utils/DataUtils";
import { generateElementIdentifier } from "utils/ApplicationUtils";
import { DATA_IDENTIFIER, ELEMENT } from "../App/app-constant";

interface CustomTableFooterInterface {
  rowsData: any;
  classes: any;
  colSpan: any;
  pageSize: any;
  rowCount: any;
  page: any;
  fetchNextRecord: any;
}

const CustomTableFooter = (props: CustomTableFooterInterface) => {
  const { rowsData, classes, colSpan, pageSize, rowCount, page, fetchNextRecord } = props;

  return (
    <TableFooter>
      <TableRow>
        {rowsData && Array.isArray(rowsData) && rowsData.length > 0 && (
          <TablePagination
            data-testid={generateElementIdentifier({ key: DATA_IDENTIFIER.PAGINATION, element: ELEMENT.TABLE })}
            className={classes.tablePaginationStyle}
            colSpan={colSpan}
            rowsPerPageOptions={[pageSize]}
            count={rowCount}
            rowsPerPage={pageSize}
            page={page}
            onPageChange={(event, pageNumber) => {
              if (!isUndefined(fetchNextRecord)) {
                fetchNextRecord(event, pageNumber ?? 0);
              }
            }}
          />
        )}
      </TableRow>
    </TableFooter>
  );
};

export default React.memo(CustomTableFooter);
